import { Navigate, Route, Routes } from 'react-router-dom';
import { CategoryDashboard } from 'pages/insights-pro/category-tab/CategoryDashboard';
import { CategoriesOverTimeReport } from 'pages/insights-pro/category-tab/reports/CategoriesOverTimeReport';
import { GmvCategoryBreakdown } from 'pages/insights-pro/category-tab/reports/gmv-category-breakdown/GmvCategoryBreakdown';

export function CategoryRoutes() {
  return (
    <Routes>
      <Route index element={<CategoryDashboard />} />
      <Route path="reports/over-time" element={<CategoriesOverTimeReport />} />
      <Route path="reports/channel-breakdown" element={<GmvCategoryBreakdown />} />
      <Route path="*" element={<Navigate to="" />} />
    </Routes>
  );
}
